import {
	FETCH_DATES_AVAILABLE_BEGIN,
	FETCH_DATES_AVAILABLE_SUCCESS,
	FETCH_DATES_AVAILABLE_FAILURE
} from '../actions/fetchPropertyAvailability'
import merge from 'lodash/merge'

const initialState = {
	availability: {},
	loading: false,
	error: null
}

export default function fetchPropertyAvailabilityReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_DATES_AVAILABLE_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_DATES_AVAILABLE_SUCCESS:
			return {
				...state,
				loading: false,
				availability: merge({}, state.availability, action.payload)
			}

		case FETCH_DATES_AVAILABLE_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			}

		default:
			return state
	}
}




// WEBPACK FOOTER //
// ./src/reducers/fetchPropertyAvailabilityReducers.js